import { GoogleOAuthProvider } from "@react-oauth/google";
import type { PropsWithChildren } from "react";
import { env } from "@/env";

export function GoogleOAuthProviderWrapper({ children }: PropsWithChildren) {
  return (
    <GoogleOAuthProvider clientId={env.VITE_GOOGLE_CLIENT_ID || ""}>
      {children}
    </GoogleOAuthProvider>
  );
}
